"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypedPlatformFunctionResponse = useTypedPlatformFunctionResponse;
const hooks_1 = require("../../../../ui/hooks");
const utils_1 = require("../../../../ui/utils");
const swr_1 = __importDefault(require("swr"));
function useTypedPlatformFunctionResponse(functionDef, request, baseUrl, tokenProvider, config) {
    const storage = (0, hooks_1.useFunctionClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(request ? ['/platform/api/v1/function/response', functionDef.name, request] : null, async () => {
        return request
            ? storage.executeFunction({ functionName: functionDef.name, params: request }).then((response) => response.result)
            : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
